// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1lAZO","label":"SetPasswdForm_label__3ujvL"};